/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const MembersIcon = /*#__PURE__*/ createSvgIcon(
  'MembersIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M2 14.083c0-.358.087-.687.26-.987.174-.3.414-.54.72-.721A9.697 9.697 0 018 11c.917 0 1.795.118 2.635.354.84.236 1.636.577 2.386 1.021.305.18.545.42.719.721.173.3.26.63.26.987v.417c0 .412-.147.766-.44 1.06-.295.293-.648.44-1.06.44H3.493c-.413 0-.765-.147-1.057-.44A1.45 1.45 0 012 14.5v-.417zM16.5 16h-1.396c.125-.236.222-.48.292-.733.07-.253.104-.508.104-.767v-.417c0-.583-.135-1.125-.406-1.625s-.636-.91-1.094-1.229c.542.111 1.066.26 1.573.448.507.188.99.42 1.448.698A1.973 1.973 0 0118 14.083v.417c0 .412-.147.766-.44 1.06-.294.293-.647.44-1.06.44zM8 10a2.893 2.893 0 01-2.125-.875A2.893 2.893 0 015 7c0-.833.292-1.542.875-2.125A2.893 2.893 0 018 4c.833 0 1.542.292 2.125.875S11 6.167 11 7s-.292 1.542-.875 2.125A2.893 2.893 0 018 10zm7-3c0 .833-.292 1.542-.875 2.125A2.893 2.893 0 0112 10c-.111 0-.215-.003-.313-.01a1.831 1.831 0 01-.312-.053c.347-.402.621-.85.823-1.343A4.174 4.174 0 0012.5 7c0-.57-.1-1.1-.302-1.594a4.858 4.858 0 00-.823-1.343c.111-.028.215-.046.313-.053.097-.007.2-.01.312-.01.833 0 1.542.292 2.125.875S15 6.167 15 7zM3.5 14.5h9v-.417a.484.484 0 00-.23-.416 8.95 8.95 0 00-2.062-.865A8.183 8.183 0 008 12.5c-.75 0-1.486.097-2.208.292a8.154 8.154 0 00-2.063.875.453.453 0 00-.229.415v.418zm4.504-6c.414 0 .767-.147 1.059-.442.291-.294.437-.649.437-1.062 0-.414-.147-.767-.442-1.059A1.456 1.456 0 007.996 5.5c-.414 0-.767.147-1.059.442A1.456 1.456 0 006.5 7.004c0 .414.147.767.442 1.059.294.291.649.437 1.062.437z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default MembersIcon;
